import {CheckIcon} from '@chakra-ui/icons'
import {Box, Text, Flex, Grid, GridItem, Divider} from '@chakra-ui/react'
import React, {useEffect, useMemo} from 'react'
import {useFormContext} from 'react-hook-form'
import Image from 'next/legacy/image'
import theme from 'theme'
import {useTranslation} from 'next-i18next'
import {EngraveTabComponentProps} from '_app/types/product'
import {engraveOptionName} from 'modules/product/utils/engraveOptionName'
import PriceText from '_app/components/PriceText'
import getCurrency from '_app/utils/localized/getCurrency'
import {useRouter} from '_app/hooks/useRouter'

const BASE_PATH = '/images/product/drawer/ornaments/'

const Ornaments = ({option, onAddOption}: EngraveTabComponentProps) => {
    const {t} = useTranslation('engraving')
    const {locale} = useRouter()
    const inputName = `${engraveOptionName(option)}.file`
    const {watch, setValue, getValues}: any = useFormContext()
    const inputValue = watch(inputName)

    const onSelect = (src: string) => {
        setValue(inputName, src)
        onAddOption()
    }

    const onRemove = () => {
        setValue('selected_engrave_options', undefined)
        setValue(inputName, null)
    }

    const images = useMemo(
        () => [
            {
                title: 'Kwiatek',
                file: 'Kwiatek.webp',
                file_to_send: 'Kwiatek.png',
            },
            {
                title: 'Motylek',
                file: 'Motylek.webp',
                file_to_send: 'Motylek.png',
            },
            {
                title: 'Rybka',
                file: 'Rybka.webp',
                file_to_send: 'Rybka.png',
            },
            {
                title: 'Ważka',
                file: 'Wazka.webp',
                file_to_send: 'Wazka.png',
            },
            {
                title: 'Żuczek',
                file: 'Zuczek.webp',
                file_to_send: 'Zuczek.png',
            },
        ],
        []
    )

    useEffect(() => {
        const data = getValues(`selected_engrave_options.${option?.value?.pendant}.front[1]`)
        if (!data) {
            onRemove()
        }
    }, [getValues()])

    return (
        <Box mb={6}>
            <Text mb={3} fontWeight={300} flexDirection="row" display="flex">
                {t('COST_OF_PAINTING')}:
                {option.value?.price && (
                    <Text pl={1} fontWeight={400}>
                        <PriceText
                            amount={{
                                value: option.value.price,
                                currency: getCurrency(locale),
                            }}
                            floating
                        />
                    </Text>
                )}
            </Text>
            <Divider mb={6}/>
            <Text mb={6} fontWeight={300}>
                {t('CHOOSE_PATTERN')}
            </Text>

            <Grid
                templateColumns={{base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)'}}
                gap={4}
            >
                {images.map(({title, file, file_to_send}) => {
                    const src = `${BASE_PATH}${file}`
                    const srcToSend = `${BASE_PATH}${file_to_send}`
                    const isSelected = inputValue === srcToSend

                    return (
                        <GridItem key={title}>
                            <Box
                                role="button"
                                cursor="pointer"
                                position="relative"
                                onClick={() => (isSelected ? onRemove() : onSelect(srcToSend))}
                                borderWidth="1px"
                                borderColor={isSelected ? 'black' : 'transparent'}
                                bg={theme.colors.lightPink}
                            >
                                <Image src={src} alt={title} width="130" height="130"/>
                                {isSelected && (
                                    <Flex
                                        position="absolute"
                                        bottom={2}
                                        right={2}
                                        bg="black"
                                        rounded="full"
                                        boxSize="16px"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <CheckIcon color="white" fontSize="8px" fontWeight={600}/>
                                    </Flex>
                                )}
                            </Box>
                        </GridItem>
                    )
                })}
            </Grid>
            {
                locale === 'pl' && (
                    <Box sx={{marginTop: '20px'}}>
                        <em>
                            W przypadku wybrania odbioru produktu w butiku stacjonarnym czas realizacji usługi malowania
                            wynosi od 2 do 7 dni roboczych.
                        </em>
                    </Box>
                )
            }
        </Box>
    )
}

export default Ornaments
